import configureTableColumnsComponentUrl from './configureTableColumnsComponent.html';

export default {
  bindings: {
    data: '<',
    labels: '<',
    onChange: '&',
    isActive: '&?',
    schema: '<?',
  },
  controllerAs: 'ctrl',
  controllerProvider: async () =>
    (await import(/* webpackChunkName: "reports" */ './configureTableColumnsComponentCtrl'))
      .default,
  templateUrl: configureTableColumnsComponentUrl,
};
